module.exports = __webpack_public_path__ + "img/CHEVRON_RIGHT.b3b023a1.svg";